export const STANDARD_MODEL_TEMPLATE_IDS = {
    pocket: {
        "simple pocket": {master: "e440a845-2dac-4ed0-8286-05427cb04661", instance: "d55212b9-f90b-44e4-a28f-06b36c758339", name: "Simple Pocket"},
        "pocket with extra lane": {
            master: "c8ed5cf0-a04a-46b7-b089-1c92e441c3a3",
            instance: "94369b6c-ff9b-4d1b-8675-a567157891cd",
            name: "Pocket with extra lane",
        },
    },
    topper: {
        "pocket topper": {master: "47a38f2d-17fc-4701-a500-90c3b1663cba", instance: "d1e530ee-5c3e-43a5-8f63-d60b48663cdb", name: "Pocket topper"},
        "waterfall topper": {master: "a9a1e33a-3f00-432a-982c-6021cb067247", instance: "142e1236-ccb5-4e58-9b26-964a5492e7e2", name: "Waterfall topper"},
        "edge topper": {master: "c76f3205-746e-46e9-a055-2636e74e111d", instance: "da72adef-5227-4283-bb92-638e075f5402", name: "Edge topper"},
    },
    waterfall: {
        "simple waterfall": {master: "fed5a358-b537-4a71-9920-65b2f20065fb", instance: "449b7e76-cbe9-441c-b199-aabd01c2d5cc", name: "Simple Waterfall"},
        "waterfall with mirror": {
            master: "f0dd902b-4086-48cc-9620-24662d16c817",
            instance: "be0c5021-40c4-478c-a992-96c776671052",
            name: "Waterfall with mirror",
        },
        "waterfall with extra lane": {
            master: "f4e6957f-edff-4a44-8908-f816d3d974ae",
            instance: "411c21d3-37f4-42a9-bf17-f39c863ec057",
            name: "Waterfall with extra lane",
        },
        "waterfall with mirror and extra lane": {
            master: "bdc7cc42-80df-4b5e-91e0-e79198e29a76",
            instance: "fe1c3234-79a7-4e81-a405-eeff80aeb1c6",
            name: "Waterfall with mirror and extra lane",
        },
        "waterfall BS006A": {master: "df157859-49a2-43b0-b755-8108d7323ebc", instance: "d435265c-7ee5-40a2-ab93-695bc7919935", name: "Waterfall BS006A"},
        "waterfall BS007A": {master: "0e2e294b-8d9f-4086-8c96-227e005db90d", instance: "b5f07273-8c73-4c8f-856d-dae0d6e9fafe", name: "Waterfall BS007A"},
        "waterfall BS012A": {master: "9af3ca8a-dd6b-45b7-817f-1cae7a544d28", instance: "2f78fe08-e91f-435d-a4c6-05019ce2e561", name: "Waterfall BS012A"},
    },
    "reversed waterfall": {
        "reversed waterfall": {
            master: "f303cece-5129-43f3-879c-b59ad0e46ace",
            instance: "4c0840e2-234d-437a-aea2-495105a3f661",
            name: "Reversed Waterfall",
        },
        "reversed waterfall with mirror": {
            master: "ad311278-7830-493c-8708-f00075c0b256",
            instance: "a4dda9c7-69b8-4b6e-8c17-36b328b3d029",
            name: "Reversed Waterfall with mirror",
        },
        "reversed waterfall with mirror on top and bottom": {
            master: "12cdf5c9-2e38-4517-a11a-27d2fffeaecf",
            instance: "4bebc8e9-b365-46f1-b0ff-428d85116b5c",
            name: "Reversed Waterfall with mirror on top and bottom",
        },
    },
    edge: {
        edge: {master: "3fd70b0d-2df5-49be-b25d-82f4f9b92ea9", instance: "476d5058-1a87-433b-ae4f-bbe738dd4b78", name: "Edge"},
        "edge with extra lane": {
            master: "081bfd73-965c-4ff8-ac14-3b13881dcda1",
            instance: "e51631a6-1434-455a-baea-be4295af2e0a",
            name: "Edge with extra lane",
        },
        "edge topper look": {master: "fbd3c697-bb1b-4e88-8f01-d6059a61fe0c", instance: "25d1fd52-b956-454e-874e-ceffd0a69ec6", name: "Edge topper look"},
        "pillow top with zipper": {
            master: "17e5a597-3a9c-47df-9d53-c66d1014aa01",
            instance: "085fe4a6-773e-4844-804b-0a6256322214",
            name: "Pillow top with zipper",
        },
    },
    "all over wrap": {
        "all over wrap": {master: "cea01061-3f4c-4e99-b9e1-c8f8cfbb89db", instance: "2cbb2387-fb1f-4b9b-975a-994ea9e7b095", name: "All Over Wrap"},
        "all over wrap with mirror": {
            master: "480cda76-4072-4c58-b5a5-24b059e787d1",
            instance: "3e8b4f99-a895-42fa-b10e-247ce2c78515",
            name: "All Over Wrap with Mirror",
        },
    },
} as const satisfies Record<string, Record<string, {master: string | null; instance: string | null; name: string}>>

export const ACCESSORY_TEMPLATE_IDS = {
    piping: {
        utility: "60337f68-abdf-4bdd-9714-cdc0c2014cb6",
        "2mm": "2f5b7de9-edce-4a96-a602-abc317574072",
        "5.5mm": "c97f5318-cb62-46e4-9525-ffbfe8f2412c",
    },
    zipper: {
        "utility:zipper": "4635646f-518c-4380-bd1e-b2a6d8e811bc",
        "utility:offset-along-curve-transform": "ebfd0d76-2c4f-4a87-aad7-f9cfdb497e8f",
        "Zipper Puller": "865559f8-f066-429e-b1c5-ff3d12289787",
        "Reverse Coil (Legacy, too dark), M3": "ab317928-4415-4ddf-82c6-da0f837cfd36",
        "Reverse Coil (Legacy, too dark), M5": "efde17de-b33b-4ea8-bb32-ff440564f2bc",
        "Reverse Coil, M3": "6eb8fcf8-0187-44c7-80c1-2b9e9b05eb5c",
        "Reverse Coil, M5": "53d920a5-5617-4dac-8945-333cabef2232",
        "Spiral Coil, M3": "79820931-2417-4874-986e-2dd551665352",
        "Spiral Coil, M5": "c9fa27f5-0bee-4890-afbc-8f4d07eab50d",
        "Teeth, M3": "16f5bc9f-0d3c-4291-afc7-6cbfafd42005",
        "Teeth, M5": "3419c2ae-a003-4781-aab6-db0344b2c7f6",
    },
    tape: {
        utility: "238d75e2-ed53-4c77-89dc-bef0c6cf408a",
        "8mm": "7afccd2f-07b9-4f9f-a361-7d1c740ca6b7",
    },
    handle: {
        "utility:vertical-handle-base-profile": "a5f26694-9cdf-4dec-acdd-acb099cefe15",
        "utility:horizontal-handle-base-profile": "6dbf969b-b2a7-4605-a9be-0cfa1f515e0c",
        "utility:handle-profile": "1a036b26-1e2f-43c6-a441-da025860f096",
        "utility:handle-mesh": null,
        "Vertical Handle, 3.5cm": "fc25db41-f469-4a81-a5df-ac47d1b66597",
        "Vertical Handle, 5.5cm": "e274108c-04d1-41e4-853d-68f174087e44",
        "Vertical Handle, 8cm": "34c934e1-a584-4f34-8117-9eacac485f42",
        "Vertical Handle, 8cm with 2mm piping": "3b10bdc1-f089-400d-8ba7-138dc13920fb",
        "Vertical Handle, 6cm with tape": "41e7eceb-0c52-44f6-8aca-84fceb1eb7c8",
        "Vertical Handle, 8m with tape": "0cdfc86b-e6ac-476e-bfaa-70fa07070868",
        "default horizontal handle": null,
        "Horizontal Handle, Cross-Stitched": "3cfb7f4d-d0f4-41de-9106-a50a430f9275",
    },
} as const satisfies Record<string, Record<string, string | null>>

export const REFERENCED_ACCESSORY_TEMPLATE_IDS = {
    "puller Round Big Hole Puller (r619) with Slider, M3": "0aa44129-35df-4e73-a34f-e1d5adf0053c",
    "puller Round Big Hole Puller (r619) with Slider, M5": "e57ed091-f191-43a1-8a34-347b03f999ca",
    "puller Square Big Hole Puller (r619) with Slider, M3": "5f95b172-7aca-4b47-b6e3-4a2ef8a251cf",
    "puller Square Big Hole Puller (r619) with Slider, M5": "eb232e34-a159-4d1d-8f9b-cbfb504b976d",
    "puller Square Puller Pointed (n51) with Slider, M3": "2278f047-5cfd-4df5-a03b-a6616e718111",
    "puller Square Puller Pointed (n51) with Slider, M5": "4b840721-b993-4286-9e76-78620ad792eb",
    "puller Square Puller with Slider, M3": "b1bc73a7-5ee8-4119-b105-1e4824af535a",
    "puller Standard Puller (YKK, n56) with Slider, M3": "7a3ac2b4-982e-498f-9d96-3aa0fcdf52cf",
    "puller Standard Puller (YKK, n56) with Slider, M5": "a30a4c71-9680-4b4b-868d-a222b46a646c",
    "vertical handle Default Vertical Handle": "04be2a42-adae-4b75-b766-ca5f99f4a8df",
    "horizontal handle Default Horizontal Handle": "6a6c33c8-45ba-4b24-8ee1-7f7636b778fb",
} as const

export const LIGHTING_TEMPLATE_ID = "ea922890-0804-4b3c-9039-e4dcb1b607a5"

export const PLANE_OVERLAY_TEMPLATE_ID = "e1a8fa22-f9e4-4697-a186-d9b8c16d3654"

export const MATTRESS_ORGANIZATION_ID = "c637d5fb-a1dd-4da1-8c12-3b69084d4ce6"

const TAG_STANDARD_ACCESSORY = "Standard Accessory"
const TAG_PIPING = "Piping"
const TAG_ZIPPER = "Zipper"
const TAG_TAPE = "Tape"
const TAG_HANDLE = "Handle"
const TAG_VERTICAL = "Vertical"
const TAG_HORIZONTAL = "Horizontal"
const TAG_STANDARD_COVER_MODEL = "Standard Cover Model"
const TAG_MATTRESS = "Mattress"
const TAG_LEGACY = "Legacy"

const PIPING_TAGS = [TAG_STANDARD_ACCESSORY, TAG_PIPING]
const ZIPPER_TAGS = [TAG_STANDARD_ACCESSORY, TAG_ZIPPER]
const LEGACY_ZIPPER_TAGS = [...ZIPPER_TAGS, TAG_LEGACY]
const TAPE_TAGS = [TAG_STANDARD_ACCESSORY, TAG_TAPE]
const VERTICAL_HANDLE_TAGS = [TAG_STANDARD_ACCESSORY, TAG_HANDLE, TAG_VERTICAL]
const HORIZONTAL_HANDLE_TAGS = [TAG_STANDARD_ACCESSORY, TAG_HANDLE, TAG_HORIZONTAL]

export const STANDARD_MODEL_TAGS: readonly string[] = [TAG_STANDARD_COVER_MODEL, TAG_MATTRESS]

export const ACCESSORY_TEMPLATE_TAGS: Record<string, Record<string, readonly string[]>> = {
    piping: {"2mm": PIPING_TAGS, "5.5mm": PIPING_TAGS},
    zipper: {
        "Reverse Coil (Legacy, too dark), M3": LEGACY_ZIPPER_TAGS,
        "Reverse Coil (Legacy, too dark), M5": LEGACY_ZIPPER_TAGS,
        "Reverse Coil, M3": ZIPPER_TAGS,
        "Reverse Coil, M5": ZIPPER_TAGS,
        "Spiral Coil, M3": ZIPPER_TAGS,
        "Spiral Coil, M5": ZIPPER_TAGS,
        "Teeth, M3": ZIPPER_TAGS,
        "Teeth, M5": ZIPPER_TAGS,
    },
    tape: {"8mm": TAPE_TAGS},
    handle: {
        "Vertical Handle, 3.5cm": VERTICAL_HANDLE_TAGS,
        "Vertical Handle, 5.5cm": VERTICAL_HANDLE_TAGS,
        "Vertical Handle, 8cm": VERTICAL_HANDLE_TAGS,
        "Vertical Handle, 8cm with 2mm piping": VERTICAL_HANDLE_TAGS,
        "Vertical Handle, 6cm with tape": VERTICAL_HANDLE_TAGS,
        "Vertical Handle, 8m with tape": VERTICAL_HANDLE_TAGS,
        "default horizontal handle": HORIZONTAL_HANDLE_TAGS,
        "Horizontal Handle, Cross-Stitched": HORIZONTAL_HANDLE_TAGS,
    },
}

export const MATERIAL_IDS = {
    defaultFabric: "f09ec9f6-1856-4479-9af3-ec36e8b7f437",
    matteSubstrate: "34d144c2-3295-4a29-9072-69768b5a17c5",
    zipperReverseCoilLegacyM3: "91a5d8ba-0f2d-41f9-9997-b2dd205a3064",
    zipperReverseCoilLegacyM5: "60948a6b-7189-433b-8cbc-e3786bfae9e0",
    zipperReverseCoilM3: "ed51653a-a991-4025-ae59-a89f2a28d9d3",
    zipperReverseCoilM5: "2998a96d-2e91-4a70-ba0d-e7469a713baf",
    zipperSpiralCoilM3: "f23db3d6-521e-4e77-afd2-f29b452d5beb",
    zipperSpiralCoilM5: "43f5e7a8-8bbe-4db8-9f7b-0f291072d407",
    zipperTeethM3: "a1a53936-76bb-4d56-8d5d-c7c61a04e173",
    zipperTeethM5: "27649a0d-ac98-45ea-aeda-a0bf0b6be793",
} as const

export const DATA_OBJECT_IDS = {
    crossStitchPattern: "f234c8a7-c2b2-485b-9ba7-89568ec63e6e",
} as const

export type StandardModelGroupKey = keyof typeof STANDARD_MODEL_TEMPLATE_IDS
export type StandardModelKey<G extends StandardModelGroupKey> = keyof (typeof STANDARD_MODEL_TEMPLATE_IDS)[G] & string
export type AccessoryGroupKey = keyof typeof ACCESSORY_TEMPLATE_IDS
export type AccessoryKey<G extends AccessoryGroupKey> = keyof (typeof ACCESSORY_TEMPLATE_IDS)[G] & string
export type ReferencedAccessoryKey = keyof typeof REFERENCED_ACCESSORY_TEMPLATE_IDS
export type MaterialKey = keyof typeof MATERIAL_IDS
export type DataObjectKey = keyof typeof DATA_OBJECT_IDS

export type LegacyIdFetcher = {
    templateLegacyIds: (ids: string[]) => Promise<{id: string; legacyId: number}[]>
    materialLegacyIds: (ids: string[]) => Promise<{id: string; legacyId: number}[]>
    dataObjectLegacyIds: (ids: string[]) => Promise<{id: string; legacyId: number}[]>
}

export type MattressSeedContext = ReadonlyMap<string, number>

export async function resolveMattressAssetLegacyIds(fetcher: LegacyIdFetcher): Promise<MattressSeedContext> {
    const templateIds = new Set<string>([LIGHTING_TEMPLATE_ID, PLANE_OVERLAY_TEMPLATE_ID, ...Object.values(REFERENCED_ACCESSORY_TEMPLATE_IDS)])

    for (const models of Object.values(STANDARD_MODEL_TEMPLATE_IDS)) {
        for (const {master} of Object.values(models)) if (master !== null) templateIds.add(master)
    }
    for (const entries of Object.values(ACCESSORY_TEMPLATE_IDS)) {
        for (const id of Object.values(entries)) if (id !== null) templateIds.add(id)
    }

    const [templates, materials, dataObjects] = await Promise.all([
        fetcher.templateLegacyIds([...templateIds]),
        fetcher.materialLegacyIds([...new Set<string>(Object.values(MATERIAL_IDS))]),
        fetcher.dataObjectLegacyIds([...new Set<string>(Object.values(DATA_OBJECT_IDS))]),
    ])

    return new Map([...templates, ...materials, ...dataObjects].map(({id, legacyId}) => [id, legacyId]))
}

const standardModelTemplateIds: Record<string, Record<string, {master: string | null; instance: string | null}>> = STANDARD_MODEL_TEMPLATE_IDS
const accessoryTemplateIds: Record<string, Record<string, string | null>> = ACCESSORY_TEMPLATE_IDS

function requireResolved(ctx: MattressSeedContext, id: string | null, label: string): number {
    if (id === null) throw new Error(`No id is registered for ${label} — add its uuid to the mattress asset catalogue in asset-ids.ts.`)
    const legacyId = ctx.get(id)
    if (legacyId === undefined) throw new Error(`Legacy id for ${label} (${id}) has not been resolved — was resolveMattressAssetLegacyIds called?`)
    return legacyId
}

export function requireStandardModelMasterTemplateLegacyId<G extends StandardModelGroupKey>(
    ctx: MattressSeedContext,
    group: G,
    model: StandardModelKey<G>,
): number {
    return requireResolved(ctx, standardModelTemplateIds[group][model].master, `master template of standard model "${group}.${model}"`)
}

export function requireAccessoryTemplateLegacyId<G extends AccessoryGroupKey>(ctx: MattressSeedContext, group: G, key: AccessoryKey<G>): number {
    return requireResolved(ctx, accessoryTemplateIds[group][key], `accessory template "${group}.${key}"`)
}

export function requireReferencedAccessoryTemplateLegacyId(ctx: MattressSeedContext, key: ReferencedAccessoryKey): number {
    return requireResolved(ctx, REFERENCED_ACCESSORY_TEMPLATE_IDS[key], `accessory template "${key}"`)
}

export function requireLightingTemplateLegacyId(ctx: MattressSeedContext): number {
    return requireResolved(ctx, LIGHTING_TEMPLATE_ID, "lighting template")
}

export function requirePlaneOverlayTemplateLegacyId(ctx: MattressSeedContext): number {
    return requireResolved(ctx, PLANE_OVERLAY_TEMPLATE_ID, "plane overlay template")
}

export function requireMaterialLegacyId(ctx: MattressSeedContext, key: MaterialKey): number {
    return requireResolved(ctx, MATERIAL_IDS[key], `material "${key}"`)
}

export function requireDataObjectLegacyId(ctx: MattressSeedContext, key: DataObjectKey): number {
    return requireResolved(ctx, DATA_OBJECT_IDS[key], `data object "${key}"`)
}
